import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SuccessModal = ({ isOpen, onClose, requestData }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleViewRequests = () => {
    navigate('/requests-management');
    onClose();
  };

  const handleCreateAnother = () => {
    onClose();
    window.location?.reload();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-50 animate-fade-in"
        onClick={onClose}
      />
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card border border-border rounded-lg shadow-overlay max-w-md w-full animate-scale-in">
          {/* Header */}
          <div className="p-6 text-center">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="CheckCircle" size={32} className="text-success" />
            </div>

            <h2 className="text-xl font-bold text-foreground mb-2">
              درخواست با موفقیت ارسال شد
            </h2>

            <p className="text-muted-foreground">
              درخواست شما برای تهیه سند حقوقی دریافت شد و در حال بررسی است
            </p>
          </div>

          {/* Request Details */}
          {requestData && (
            <div className="px-6 pb-4">
              <div className="bg-muted rounded-lg p-4 space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-muted-foreground">
                    شماره درخواست:
                  </span>
                  <span className="text-sm font-medium text-foreground">
                    REQ-{Date.now()?.toString()?.slice(-6)}
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <span className="text-sm text-muted-foreground">
                    نوع پرونده:
                  </span>
                  <span className="text-sm font-medium text-foreground">
                    {requestData?.caseType === 'judicial_statement' &&
                      'اظهارنامه قضایی'}
                    {requestData?.caseType === 'complaint' && 'شکایت'}
                    {requestData?.caseType === 'petition' && 'لایحه'}
                  </span>
                </div>

                <div className="flex justify-between items-center">
                  <span className="text-sm text-muted-foreground">
                    زمان تقریبی آماده‌سازی:
                  </span>
                  <span className="text-sm font-medium text-primary">
                    ۲۴-۴۸ ساعت
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Actions */}
          <div className="p-6 pt-2 space-y-3">
            <Button
              variant="default"
              onClick={handleViewRequests}
              iconName="FileText"
              iconPosition="left"
              fullWidth>
              مشاهده درخواست‌ها
            </Button>

            <Button
              variant="outline"
              onClick={handleCreateAnother}
              iconName="Plus"
              iconPosition="left"
              fullWidth>
              ایجاد درخواست جدید
            </Button>

            <Button variant="ghost" onClick={onClose} fullWidth>
              بستن
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessModal;
